<template>
  <div class="pb-3">
      <div class="row">
      <div class="col-12 d-flex justify-content-between flex-wrap">
        <div style="flex:1;" class="d-flex align-items-center">
          <h2 class="view-title">Administra tu cuenta</h2>
        </div>
        
        <div class="container-actions-dashboard d-flex justify-content-end mt-2 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
          <div class="d-flex">
              <button
                class="btn btn-outlined mr-2 d-flex align-items-center"
                type="button"
                @click="redirectToconfigurations()"
              >
                <img src="@/assets/icons/undo.svg" alt width="15px" class="mr-2" />
                Regresar a configuración
              </button>
              <button class="btn btn-save mr-2 d-flex align-items-center" @click="saveChanges()">
                 <img src="@/assets/icons/guardar.svg" width="18" class="mr-2">
                Guardar cambios
              </button>
            </div>
      
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mt-3">
        <p class="content-text">
          Realiza ajustes a tu cuenta de Cotizarlo. Actualiza tu correo o reestablece tu contraseña.
        </p>
      </div>
    </div>
    <div class="row">
        <div class="col-xl-4 col-lg-6 col-md-6">
            <div class="cotizarlo-general-wrapper wrapper-padding">
                <h3 class="subtitle-section">Usuario</h3>
                <div class="d-flex align-items-center justify-content-between w-75 my-3" v-if="!formName">                 
                  <p class="content-text my-0">{{this.user_config.name.name}} {{this.user_config.name.last_name}}</p>                  
                  <img class="pointer-hover mr-3" src="@/assets/icons/edit.svg" width="20px" @click="editName()"/>                 
                </div>
                <div class="form row" v-else>
                  <div class="form col">
                    <div class="input-field form-control">
                      <input type="text" class="main-input " id="name" v-model="user_config.name.name" placeholder="this.user_config.name.name">
                      <label for="name" class="main-label">Nombre</label>
                    </div>
                  </div>
                  <div class="form col">
                    <div class="input-field form-control">
                      <input type="text" class="main-input " id="lastname" v-model="user_config.name.last_name" placeholder="this.user_config.name.last_name">
                      <label for="lastname" class="main-label">Apellido</label>
                    </div>
                  </div>
                  <img src="@/assets/icons/correct.svg" width="15" class="hover-pointer" @click="confirmEdit()">
                </div>

                <div class="d-flex align-items-center justify-content-between w-75 my-3" v-if="!formEmail">              
                  <p class="content-text my-0">{{this.user_config.email}}</p>
                  <img class="pointer-hover mr-3" src="@/assets/icons/edit.svg" width="20px" @click="editEmail()"/>              
                </div>

                 <div class="form row" v-else>
                  <div class="form col">
                    <div class="input-field form-control">
                      <input type="text" class="main-input " id="email" v-model="user_config.email" placeholder="this.user_config.email">
                      <label for="email" class="main-label">Correo eléctronico</label>
                    </div>
                  </div>
                  <img src="@/assets/icons/correct.svg" width="15" class="hover-pointer" @click="confirmEdit()">
                </div>


                <div class="d-flex align-items-start justify-content-between w-75 my-3" v-if="!formPassword">
                  <div>
                    <p class="content-text my-0">Contraseña</p>
                    <p class="text-inactive small">**********</p>
                  </div>
                  <img class="pointer-hover mr-3" src="@/assets/icons/edit.svg" width="20px" @click="editPassword()"/>
                </div>
                <div class="form row" v-else>
                  <div class="form col">
                    <div class="input-field form-control">
                      <input type="password" class="main-input " id="password" v-model="user_config.password" placeholder="this.user_config.password">
                      <label for="password" class="main-label">Nueva contraseña</label>
                    </div>
                  </div>
                  <img src="@/assets/icons/correct.svg" width="15" class="hover-pointer" @click="confirmEditPassword()">
                </div>
            </div>
            <div class="d-flex align-items-center mt-3">
              <img class="pointer-hover mx-3" src="@/assets/icons/delete.svg" width="25px" @click="deleteAccount()"/>
              <span class="text-content my-0">Eliminar cuenta</span>
            </div>
        </div>
    </div>
  </div>
</template>


<script>
import profileConfiguration from '@/api/profile_configuration.js'
import data from '@/mixins/data'

export default {
  mixins: [data],
  beforeMount() {
    this.getData()
  },

  data() {
    return {
      user_config : {
        name:{
          name : null,
          last_name : null
        },
        email: null,
        password : null,
        password_change : false
      },
      formName : false,
      formEmail : false,
      formPassword: false
    }
  },
  methods: {
    getData(){
      this.user_config.name.name = this.user.name
      this.user_config.name.last_name = this.user.last_name
      this.user_config.email = this.user.email
    },
    editName(){
      this.formName = true,
      this.formEmail = false,
      this.formPassword= false
    },
    editEmail(){
      this.formName = false,
      this.formEmail = true,
      this.formPassword= false
    },
    editPassword(){
      this.formName = false,
      this.formEmail = false,
      this.formPassword= true
    },
    confirmEdit(){
      this.formName = false,
      this.formEmail = false,
      this.formPassword= false
    },
    confirmEditPassword(){
      this.formName = false,
      this.formEmail = false,
      this.formPassword= false,
      this.user_config.password_change = true
    },
    saveChanges(){
      this.formName = false,
      this.formEmail = false,
      this.formPassword= false

      let data = new FormData()

      data.append("name", this.user_config.name.name)
      data.append("last_name", this.user_config.name.last_name)
      data.append("email", this.user_config.email)
      data.append("password_change", this.user_config.password_change)
      
    
      this.user_config.password_change && this.user_config.password != null ? data.append("password", this.user_config.password) : null

      this.$store.dispatch('showLoader',{show:true});

      profileConfiguration
      .updateMeData(data)
      .then((response) => {
        this.$store.dispatch('updateUser').then(
          () => {
            this.$store.dispatch('showLoader',{show:false});
            this.$store.dispatch('showMessage',{
              action:'success',
              message:response.data.message
            });  
          }
        );
      })
      .catch(() => {
        this.$store.dispatch('showLoader',{show:false});
      });
    },
    redirectToconfigurations(){
      if (confirm('¿Estás seguro?')) this.$router.push('/configuracion');
    },
    deleteAccount(){
      this.$swal({
          title: "¿Estás seguro?",
          text:"Ésta cuenta será eliminada. Esta acción no puede deshacerse",
          
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "Cancelar",
          confirmButtonText:
            'Eliminar',
      }).then((result)=>{
        if(result.value){
          profileConfiguration
          .deleteAccount()
          .then((response) => {
            this.getData()
            this.$store.dispatch('showMessage',{
            action:'success',
            message:response.data.message
            });  
          })
          .catch(() => {
            this.$store.dispatch('showLoader',{show:false});
          });
        }
      })
    }
  }
}
</script>

